import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { OVERLAYS } from '../../constants';
import { OverlayState } from '../../recoil/overlay/overlay.state';
import ChannelOverlay from '../overlay/channel.overlay';
import EventOverlay from '../overlay/event.overlay';
import FeedOverlay from '../overlay/feed.overlay';
import OverlayController from '../utility/overlay-controller';

export default function Overlays() {
  const [state, set] = useRecoilState(OverlayState);

  const handleClose = () => {
    set((prev) => ({ ...prev, shouldShow: false, current: null }));
  };

  useEffect(() => {
    state.shouldShow
      ? document.querySelector('body')?.classList.add('no-scroll')
      : document.querySelector('body')?.classList.remove('no-scroll');
    const handleEsc = (event: any) => {
      if (event.keyCode === 27) {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [state.shouldShow]);

  return (
    <OverlayController overlays={OVERLAYS}>
      <OverlayController.Overlay name="SOCIAL_FEED">
        <FeedOverlay />
      </OverlayController.Overlay>
      <OverlayController.Overlay name="EVENT">
        <EventOverlay />
      </OverlayController.Overlay>
      <OverlayController.Overlay name="CHANNEL">
        <ChannelOverlay />
      </OverlayController.Overlay>
    </OverlayController>
  );
}
